module.exports = __webpack_public_path__ + "img/5.db574cba.png";